import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import loginPageStyle from 'assets/jss/material-dashboard-react/views/loginPageStyle.jsx';
import { Navigate, useParams } from 'react-router-dom';
import * as loginActions from 'actions/LoginActions';
import * as networkActions from 'actions/NetworkActions';
import * as defaultActions from 'actions/DefaultActions';
import UndefinedErrorSnackbar from 'components/Snackbar/UndefinedErrorSnackbar';
import LoginComp from './Login/LoginComp';

const Login = (props) => {
  const { classes } = props;
  const { login, defaultStates } = props;
  const { onLogin, onLoginSSO } = props.loginActions;
  const { getNetworkByName, getNetworkByAPIKey } = props.networkActions;
  const [redirectToNetwork, setRedirectToNetwork] = useState(false);
  const [refreshLogin, setRefreshLogin] = useState(false);
  const [showLoadingPage, setShowLoadingPage] = useState(true);
  const { workflow_title } = useParams();
  const { network_name } = useParams();
  const { application_id } = useParams();

  useEffect(() => {
    if (localStorage.getItem('network_api_key')) {
      setShowLoadingPage(false);
    } else {
      setShowLoadingPage(true);
      if (network_name !== undefined) {
        getNetworkByName(network_name);
        setRefreshLogin(true);
      } else {
        var envApiKey = process.env.REACT_APP_API_KEY;
        if (envApiKey !== undefined) {
          getNetworkByAPIKey(envApiKey);
          setRefreshLogin(true);
        } else {
          setRedirectToNetwork(true);
        }
      }
    }
  }, []);

  if (localStorage.getItem('token')) {
    return <Navigate to="/list" />;
  }

  if (login.chooseWorkflow) {
    return <Navigate to="/public/choose-workflow" />;
  }

  if (redirectToNetwork) {
    return <Navigate to="/public/network" />;
  }

  if (refreshLogin) {
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }

  if (showLoadingPage) {
    return (
      <div>Loading...</div>
    );
  }

  return (
    <div className={classes.content}>
      <div className={classes.container}>
        {defaultStates.unDefinedError ? <UndefinedErrorSnackbar error_code={defaultStates.error} /> : ''}
        <div>
          <LoginComp
            workflow_title={workflow_title}
            application_id={application_id}
            network_name=""
            requesting={login.requesting}
            message={login.message}
            error_code={login.error_code}
            onLogin={onLogin}
            onLoginSSO={onLoginSSO}
            classes={props}
            loggedIn={login.loggedIn}
          />
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    login: state.login,
    defaultStates: state.defaultStates,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loginActions: bindActionCreators(loginActions, dispatch),
    networkActions: bindActionCreators(networkActions, dispatch),
    defaultActions: bindActionCreators(defaultActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(loginPageStyle)(Login));
